import { render, staticRenderFns } from "./ContentTab1.vue?vue&type=template&id=3f62d626&scoped=true"
import script from "./ContentTab1.vue?vue&type=script&lang=ts"
export * from "./ContentTab1.vue?vue&type=script&lang=ts"
import style0 from "./ContentTab1.vue?vue&type=style&index=0&id=3f62d626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62d626",
  null
  
)

export default component.exports